import Splide from '@splidejs/splide';

export default class WCCartCrossSellSlider {
    constructor() {
        this.crossSellSlider = document.querySelector(
            '.jsWcCartCrossSellSlider',
        );

        this.cartGrid = document.querySelector('.jsWcCartGrid');

        if (this.crossSellSlider) {
            this.events();
        }
    }

    events() {
        this.initializeCrossSellSlider(this.crossSellSlider);
    }

    initializeCrossSellSlider(crossSellSlider) {
        // eslint-disable-next-line no-unused-vars
        this.activeSlider = new Splide(crossSellSlider, {
            type: 'carousel',
            rewind: false,
            arrows: true,
            pagination: false,
            perPage: 5,
            perMove: 1,
            gap: '1.25rem',
            classes: {
                // Add classes for arrows.
                arrows: 'wcc-related__splide__arrows',
                arrow: 'wcc-related__splide__arrow',
                prev: 'wcc-related__splide__arrow--prev',
                next: 'wcc-related__splide__arrow--next',
            },
            breakpoints: {
                1023: {
                    perPage: 4,
                },
                959: {
                    perPage: 3,
                },
                767: {
                    destroy: true,
                },
            },
        });

        this.activeSlider.on('mounted', () => {
            this.cartGrid.dispatchEvent(
                new CustomEvent('crossSellSliderActive'),
            );
        });

        this.activeSlider.mount();
    }
}
